export default __webpack_public_path__ + "static/media/Smart-Biology-LIFE-U5-Cover-Image.4caa30d1.jpg";